import React, {useEffect, useState} from 'react';
import LayoutContentWrapper from "../LayoutContentWrapper/LayoutContentWrapper";
import {Navigation} from "./Navigation/Navigation";
import {HeaderTop} from "./HeaderTop/HeaderTop";
import style from "./Header.module.css";
import useResizeObserver from "use-resize-observer";
import {useAppDispatch} from "../../../hooks/redux";
import {appSlice} from "../../../store/reducers/AppSlice";


const Header = () => {


    const [heightHeader, setHeightHeader] = useState<number>(0)
    const dispatch = useAppDispatch()

    const {ref} = useResizeObserver<HTMLDivElement>({
        onResize: ({width, height}) => {
            if (height && heightHeader !== height) {
                setHeightHeader(height)
            }
        },
    });

    useEffect(() => {
        if (heightHeader) {
            dispatch(appSlice.actions.setHeightHeader(heightHeader))
        }
    }, [dispatch, heightHeader])

    return (
        <header className={style.fixedHeader} style={{height: `${heightHeader}px`}}>
            <div ref={ref} className={style.wrapperForFixed}>
                <LayoutContentWrapper>
                    <header className={style.header}>
                        <HeaderTop/>
                        <Navigation key={'header'}/>
                    </header>
                </LayoutContentWrapper>
            </div>
        </header>
    );
};

export default Header;



